import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { customPalette } from '../themes/customTheme';
import { apiUrl, httpClient } from '../utils/httpUtils';

export const SelectFieldTeams = ({ teamSelected, setTeam, teams = [] }) => {
  const t = useTranslate();
  const [teamsApi, setTeamsApi] = useState(teams);
  const getTeams = async () => {
    try {
      const url = `${apiUrl}/teams?page=1&size=800`;
      const res = await httpClient(url);
      if (res.status === 200) {
        const data = await res.json.data;
        setTeamsApi(data);
      }
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
    }
  };

  useEffect(() => {
    if (teams.length === 0) {
      getTeams();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl>
      <InputLabel
        id="demo-simple-select-label"
        sx={{
          marginTop: '-4px',
          '&.Mui-focused': {
            transform: 'translate(13px, 7px) scale(0.75) !important',
            color: customPalette.primary.main,
            fontWeight: 500,
          },
          '&.MuiInputLabel-shrink': {
            transform: 'translate(13px, 7px) scale(0.75)',
            color: customPalette.primary.main,
            fontWeight: 500,
          },
        }}
      >
        {t('resources.score.list.fields.team')}
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={teamSelected || undefined}
        onChange={event => setTeam(event.target.value)}
        sx={{
          width: 190,
          height: 45,
          fieldset: {
            height: 45,
            top: 0,
          },
          fontSize: '14px',
          legend: {
            position: 'absolute',
          },

          '.MuiSelect-select': {
            paddingTop: '20px !important',
            paddingBottom: '4px !important',
          },
          svg: {
            paddingBottom: '4px !important',
          },
        }}
      >
        <MenuItem value="">
          <em>{t('resources.score.list.fields.all')}</em>
        </MenuItem>
        {teamsApi.map(team => (
          <MenuItem
            key={team.id}
            value={team.id}
            sx={{
              fontSize: '14px',
              color: customPalette.greyDark,
              paddingTop: '6px !important',
              paddingBottom: '6px !important',
            }}
          >
            {team.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
